import { fabric } from 'fabric'
import { v4 as uuidv4 } from 'uuid'
import { TemplateTextbox } from '../objects/TemplateTextbox'
import { TemplateImage } from '../objects/TemplateImage'
import { PromptTextbox } from '../objects/PromptTextbox'

const _createName = (name, id) => `${name}-${id.slice(0, 5)}`

export const canvasActions = {
    addRectangle: (canvas) => {
        const id = uuidv4()
        const rect = new fabric.Rect({
            id: id,
            name: _createName('rectangle', id),
            top: 100,
            left: 100,
            width: 100,
            height: 100,
            fill: 'black',
        })
        canvas.add(rect)
        canvas.setActiveObject(rect)
        canvas.renderAll()
    },

    addCircle: (canvas) => {
        const id = uuidv4()
        const circle = new fabric.Circle({
            id: id,
            name: _createName('circle', id),
            top: 100,
            left: 100,
            radius: 20,
            fill: 'black',
        })
        canvas.add(circle)
        canvas.setActiveObject(circle)
        canvas.renderAll()
    },

    addTriangle: (canvas) => {
        const id = uuidv4()
        const tri = new fabric.Triangle({
            id: id,
            name: _createName('triangle', id),
            top: 100,
            left: 100,
            width: 100,
            height: 100,
            fill: 'black',
        })
        canvas.add(tri)
        canvas.setActiveObject(tri)
        canvas.renderAll()
    },

    addImage: (imgData, canvas) => {
        const id = uuidv4()
        fabric.Image.fromURL(
            imgData,
            function (oImg) {
                console.log('adding img')
                var scale = 200 / oImg.width
                oImg.set({ scaleX: scale, scaleY: scale })
                canvas.add(oImg)
                canvas.setActiveObject(oImg)
                canvas.renderAll()
            },
            {
                id: id,
                name: _createName('image', id),
            }
        )
    },

    addTemplateImage: (imgData, canvas) => {
        const id = uuidv4()
        TemplateImage.fromURL(
            imgData,
            function (bi) {
                bi.set({
                    width: 100,
                    height: 100,
                })
                canvas.add(bi)
                canvas.setActiveObject(bi)
                canvas.renderAll()
            },
            {
                id: id,
                name: _createName('template-image', id),
            }
        )
    },

    addTemplateTextbox: (canvas) => {
        const id = uuidv4()
        const tb = new TemplateTextbox('I will be replaced with text', {
            id: id,
            name: _createName('template-textbox', id),
        })
        tb.setControlsVisibility({
            mb: false,
            mt: false,
        })

        canvas.add(tb)
        canvas.setActiveObject(tb)
        canvas.renderAll()
    },

    addTextbox: (canvas) => {
        const id = uuidv4()
        const tb = new fabric.Textbox('I am a static textbox', {
            id: id,
            name: _createName('textbox', id),
        })
        tb.setControlsVisibility({
            mb: false,
            mt: false,
        })
        canvas.add(tb)
        canvas.setActiveObject(tb)
        canvas.renderAll()
    },

    addPromptTextbox: (canvas) => {
        const id = uuidv4()
        const tb = new fabric.PromptTextbox('I am an AI-assisted textbox', {
            id: id,
            name: _createName('prompt-textbox', id),
            prompt: null,
        })
        tb.setControlsVisibility({
            mb: false,
            mt: false,
        })
        canvas.add(tb)
        canvas.setActiveObject(tb)
        canvas.renderAll()
    },

    takeScreenshot: (canvas) => {
        return canvas.toDataURL({
            format: 'png',
            multiplier: 2,
        })
    },
}
